import rest from '../../rest/config'

// 销售接待设置 统一数据存储  暂时有意向等级, 来店类型

const state = {
  actionLevels: [],
  configTypes: [],
  customerInfo: {}
}

const actions = {
  fetchCustomerInfo({ commit }, { customerId, plateNumber, storeId }) {
    if (customerId) {
      return rest.carRegister.getCustomerInfo(customerId)().then((res) => {
        if (res.code !== 0) {
          return
        }
        commit('UPDATE_CAR_REGISTER_CUSTOMER_INFO', res.data.customer_info)
      })
    }
    if (plateNumber) {
      const query = {
        plate_number: plateNumber
      }
      return rest.carRegister.getCustomerInfoWithPlateNumber(query).then((res) => {
        if (res.code !== 0) {
          return
        }
        commit('UPDATE_CAR_REGISTER_CUSTOMER_INFO', res.data.customer_info)
      })
    }
  },
  fetchActionConfigs({
    commit
  }, {
    configType
  }) {
    return rest.carRegister.getSaleConfig({
      config_type: configType,
      page: 1,
      count: 200
    }).then((res) => {
      if (res.code !== 0) {
        return
      }

      const result = res.data.configs.map(item => {
        return {
          key: item.id,
          value: item.name
        }
      })
      const commitTypes = {
        1: 'UPDATE_CAR_REGISTER_ACTION_LEVELS',
        2: 'UPDATE_CAR_REGISTER_CONFIG_TYPES'
      }
      commit(commitTypes[configType], result)
      return res.data
    })
  },
  async fetchAllConfigs({
    dispatch
  }) {
    await dispatch('fetchActionConfigs', {
      configType: 1
    })
    await dispatch('fetchActionConfigs', {
      configType: 2
    })
  }
}

const mutations = {
  'UPDATE_CAR_REGISTER_ACTION_LEVELS': function (state, configInfo) {
    state.actionLevels = configInfo
  },
  'UPDATE_CAR_REGISTER_CONFIG_TYPES': function (state, configInfo) {
    state.configTypes = configInfo
  },
  'UPDATE_CAR_REGISTER_CUSTOMER_INFO': function(state, customerInfo) {
    state.customerInfo = customerInfo
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
